module.exports = __webpack_public_path__ + "static/media/Bishop Letter.283657b0.docx";